<template>
  <div class="all_part" @click="bar_notShow">
    <div class="head">
      <div class="back" v-show="this.$store.state.pan_CloseNotShow==0"> </div>
      <div class="back" @click="back" v-show="this.$store.state.pan_CloseNotShow==1">
        <img src="../assets/main_menu_Phone/back.png" alt="" width="25px"/>
      </div>
      <div class="titleAndicon">
        <div class="titleName">
          <span>应收款与发票</span>
        </div>
        <div class="title_icon" @click="navbarShow"  @click.stop>
          <img src="../assets/ProductTablePhone_img/icon.png" alt="" width="30px"/>
        </div>
      </div>
    </div>
    <div class="heads" v-if="PanDuanShou" >
      <div class="heads_menus" v-if="user_leave.standardType == 1">
        <div class="heads_menu_icon">
          <img
            src="../assets/Main_menu_img/Litle_menu_icon/JiaGeKuCun.png"
            alt=""
          />
        </div>
        <div class="heads_button" @click="Second_jiage">
          <span>价格与库存</span>
        </div>
      </div>
      <dir class="heads_menu" v-if="user_leave.master_gear == 1">
        <div class="heads_menu_icon">
          <img
            src="../assets/Main_menu_img/Litle_menu_icon/ICChanPinXinXi.png"
            alt=""
          />
        </div>
        <div class="heads_button" @click="Second_ZhuDang">
          <span>IC市场信息</span>
        </div>
      </dir>
      <dir class="heads_menu" v-if="user_leave.competitive_products == 1">
        <div class="heads_menu_icon">
          <img
            src="../assets/Main_menu_img/Litle_menu_icon/NeiBuXieTiao.png"
            alt=""
          />
        </div>
        <div class="heads_button" @click="TableInputPhone">
          <span>IC市场情报</span>
        </div>
      </dir>
      <dir class="heads_menu" v-if="user_leave.task == 1">
        <div class="heads_menu_icon">
          <img
            src="../assets/Main_menu_img/Litle_menu_icon/JiaGeKuCun.png"
            alt=""
          />
        </div>
        <div class="heads_button" @click="NeiBuXieTiao">
          <span>内部协调</span>
        </div>
      </dir>
      <dir class="heads_menu" v-if="user_leave.financeType == 1">
        <div class="heads_menu_icon">
          <img
            src="../assets/Main_menu_img/Litle_menu_icon/YingShouKuanYuFaPiao.png"
            alt=""
          />
        </div>
        <div class="heads_button" @click="FinancePhone">
          <span>应收款与发票</span>
        </div>
      </dir>
      <dir class="heads_menu" v-if="user_leave.orderType == 1">
        <div class="heads_menu_icon">
          <img
              src="../assets/Main_menu_img/Litle_menu_icon/YingShouKuanYuFaPiao.png"
              alt=""
          />
        </div>
        <div class="heads_button" @click="DingDanZhongXin">
          <span>订单中心</span>
        </div>
      </dir>
    </div >
    <div class="input_button" v-if="PanDuanShous">
      <div class="ss"></div>
      <div class="all_input">
        <div class="all_input_top">
          <div class="two_inputs">
            <div>
              <el-input
                v-model="name"
                placeholder="客户简称"
                style="width: 135pt"
              ></el-input>
            </div>
            <div>
              <el-input
                v-model="be_overdue"
                placeholder="逾期天数"
                style="width: 135pt"
              ></el-input>
            </div>
          </div>
          <!-- <div class="two_inputs">
            <div>
              <el-input
                v-model="name"
                placeholder="客户"
                style="width: 135pt"
              ></el-input>
            </div>
            <div>
              <el-input
                v-model="full_name"
                placeholder="客户全称"
                style="width: 135pt"
              ></el-input>
            </div>
          </div> -->
        </div>
        <div class="submit_button">
          <div class="search_buttons">
            <el-button
              type="primary"
              @click="Financeinfo"
              style="
                height: 34pt;
                width: 97pt;
                background-image: linear-gradient(to right, #358fe5, #1d6eb9);
              "
              >搜索
            </el-button>
          </div>
          <div class="all_second_button">
            <div class="second_button" @click="clearInput">
              <el-button plain type="primary" style="width: 92px; height: 48px"
                >重置
              </el-button>
            </div>
            <!--            <div class="second_button">-->
            <!--              <el-button plain type="primary" style="width: 92px; height: 48px "-->
            <!--                         @click="inputShow" >{{ PanDuanShou?'收起':'展开' }}-->
            <!--              </el-button-->
            <!--              >-->
            <!--            </div>-->
          </div>
        </div>
<!--        <div class="ShouQi" @click="inputShow">-->
<!--          <img src="../assets/ProductTablePhone_img/组 3.png" alt="" />-->
<!--        </div>-->
      </div>
    </div>
<!--    <div class="ShouQis" @click="inputShow" v-if="!PanDuanShous">-->
<!--      <img src="../assets/ProductTablePhone_img/组 3.png" alt="" />-->
<!--    </div>-->
    <div class="all_key">
      <div v-for="(item, i) in tableData" class="list_div">
        <div class="Key">
          <span>客户</span>
          <span>{{ item.name }}</span>
        </div>
        <div class="Key">

          <span>客户全称</span>
          <span>{{ item.full_name }}</span>
        </div>
        <div class="Key">
          <span>销售人员</span>
          <span>{{ item.salesman }}</span>
        </div>
        <div class="Key">
          <span>SAP系统账期</span>
          <span>{{ item.accounting_period }}</span>
        </div>
        <div class="Key">
          <span>到账说明</span>
          <span>{{ item.description }}</span>
        </div>
        <div class="Key">
          <span>付款条件</span>
          <span>{{ item.term_of_payment }}</span>
        </div>
        <div class="Key">
          <span>发票号码</span>
          <span>{{ item.invoice_number }}</span>
        </div>
        <div class="Key">
          <span>本币金额</span>
          <span>{{ item.money }}</span>
        </div>
        <div class="Key">
          <span>货款到期日</span>
          <span>{{ item.payment_due_date }}</span>
        </div>
        <div class="Key">
          <span>逾期天数</span>
          <span>{{ item.be_overdue }}</span>
        </div>
        <div class="Key">
          <span>快递单号</span>
          <span>{{ item.courier_number }}</span>
        </div>
<!--        <div class="Key">-->
<!--          <span>凭证日期</span>-->
<!--          <span>{{ item.document_date }}</span>-->
<!--        </div>-->
<!--        <div class="Key">-->
<!--          <span>凭证编号</span>-->
<!--          <span>{{ item.document_number }}</span>-->
<!--        </div>-->







<!--        <div class="Key">-->
<!--          <span>公司代码</span>-->
<!--          <span>{{ item.company_code }}</span>-->
<!--        </div>-->


      </div>
    </div>
  </div>
</template>

<script>
import { httpUrl } from "../components/publics";

export default {
  data() {
    return {
      be_overdue:"",
      user_leave: {},
      PanDuanShous: true,
      PanDuanShou: false,
      pageStats: "",
      tableData: [],
      company_Code: "",
      document_date: "",
      name:"",
      full_name: "",
      page: "",
    };
  },
  watch: {
    $route() {
      //跳转到该页面后需要进行的操作
    },
  },

  mounted() {
    window.addEventListener('scroll', this.lazyLoading); // 滚动到底部，再加载的处理事件
    this.getUser();
    this.serchFinanceinfo();
  },

  methods: {
    lazyLoading () { // 滚动到底部，再加载的处理事件
      let scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
      let clientHeight = document.documentElement.clientHeight;
      let scrollHeight = document.documentElement.scrollHeight;
      if (scrollTop + clientHeight >= scrollHeight) { // 滚动到底部，逻辑代码
        //事件处理
        if(this.be_overdue==""||this.name==""){
          console.log("我已经滚动到底部了触发这个事件了")//此处可以添加数据请求
          this.page++;
          this.serchFinanceinfo()
        }else{
          console.log("這個是查詢后的嬾加載")//此处可以添加数据请求
          this.page++;
          this.Financeinfo()
        }

      }
    },
    bar_notShow() {
      this.PanDuanShou = false;
    },
    Second_jiage() {
      this.$router.push("/Main_menuPhone_JiaGeYuKuCun");
    },
    Second_ZhuDang() {
      this.$router.push("/ICChanPinXinXi_phone");
    },
    TableInputPhone() {
      this.$router.push("/TableInputPhone");
    },
    NeiBuXieTiao() {
      this.$router.push("/missionPhone");
    },

    FinancePhone() {
      this.$router.push("/FinancePhone");
    },
    DingDanZhongXin() {
      this.$router.push("/OrderPlone");
    },
    inputShow() {
      if (this.PanDuanShous) {
        this.PanDuanShous = !this.PanDuanShous;
      } else {
        this.PanDuanShous = !this.PanDuanShous;
      }
    },
    navbarShow() {
      if (this.PanDuanShou) {
        this.PanDuanShou = !this.PanDuanShou;
      } else {
        this.PanDuanShou = !this.PanDuanShou;
      }
    },
    getUser() {
      this.user_leave = JSON.parse(sessionStorage.getItem("user"));
      console.log(this.user_leave);
    },
    back() {
        this.$router.push("/Main_menuPhone");
    },

    clearInput() {
      this.company_Code = "";
      this.   be_overdue = "";
      this.document_date = "";
      this.name = "";
      this.full_name = "";
    },
    reflash(val) {
      this.page = val;
      this.serchFinanceinfo();
    },
    serchFinanceinfo() {
      this.axios
        .get(
          httpUrl +
            `/api/index/finance?name=${this.name}&be_overdue=${this.be_overdue}&page=${this.page}`
        )
        .then((response) => {
          // const loading = this.$loading({
          //   lock: true,//lock的修改符--默认是false
          //   text: 'Loading',//显示在加载图标下方的加载文案
          //   spinner: 'el-icon-loading',//自定义加载图标类名
          //   background: 'rgba(128, 128, 128, 0.4)',//遮罩层颜色
          //   target: document.querySelector('all_part')//loadin覆盖的dom元素节点
          // });

          if (response.data.code == 200) {
            // loading.close();
            // console.log(this.page)
            let testDate =  response.data.data.data
            // this.tableData = response.data.data.data;
            let a = testDate.map(value=>{
                // let b = ;
              this.tableData .push(value)
                // console.log(this.tableData)
            })
            // console.log(a)
            //
            // console.log(this.tableData);
            // console.log(this.page)
          }
          // this.$message("搜索成功");
          console.log("success", response.data);
        })
        .catch((error) => console.log(error, "error"));
    },
    Financeinfo() {
      this.tableData =[]
      this.page=0;
      this.axios
          .get(
              httpUrl +
              `/api/index/finance?name=${this.name}&be_overdue=${this.be_overdue}&page=${this.page}`
          )
          .then((response) => {
            // const loading = this.$loading({
            //   lock: true,//lock的修改符--默认是false
            //   text: 'Loading',//显示在加载图标下方的加载文案
            //   spinner: 'el-icon-loading',//自定义加载图标类名
            //   background: 'rgba(128, 128, 128, 0.4)',//遮罩层颜色
            //   target: document.querySelector('all_part')//loadin覆盖的dom元素节点
            // });

            if (response.data.code == 200) {
              // loading.close();
              // console.log(this.page)
              let testDate =  response.data.data.data
              // this.tableData = response.data.data.data;
              let a = testDate.map(value=>{
                // let b = ;
                this.tableData .push(value)
                // console.log(this.tableData)
              })
              // console.log(a)
              //
              // console.log(this.tableData);
              // console.log(this.page)
            }
            // this.$message("搜索成功");
            console.log("success", response.data);
          })
          .catch((error) => console.log(error, "error"));
    },
  },
  destroyed() {
    window.removeEventListener('scroll', this.lazyLoading);
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.lazyLoading);
    this.lazyLoading()
  },
};
</script>

<style>
</style>

<style scoped>
.heads_menus {
  padding: 0;
  margin: 0;
  width: 74%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  border-bottom: rgb(235, 235, 235) 1px solid;
  align-items: center;
}
.heads {

  padding-top: 40px;
  flex-direction: column;
  width: 42%;
  justify-content: space-around;
  display: flex;
  align-items: center;
  height: 300px;
  background-color: #ffffff;
  position: fixed;
  right: 0;
  z-index: 98;
  border-radius: 4px;
  box-shadow: 2px 1px 6px 6px #ccc;
}

.heads span {
  color: #000;
  font-size: 13px;
  line-height: 20px;
  font-weight: 250;
}
.heads_button {
  width: 70%;
  height: 40px;
  display: flex;

  align-items: center;
  justify-content: center;
}
.heads_menu {
  padding: 0;
  margin: 0;
  width: 74%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  border-bottom: rgb(235, 235, 235) 1px solid;
  align-items: center;
}
.heads_menu_icon img {
  width: 24px;
}
.head span {
  color: #ffffff;
  font-size: 20px;
  line-height: 20px;
  font-weight: 550;
}
.list_div_div {
  width: 30%;
  display: flex;
  flex-direction: column;
  margin-right: 10px;
}
.all_part {
  /*height: 100vh;*/
  background-color: #f2f2f2;
}

.head {
  width: 100%;
  justify-content: space-between;
  display: flex;
  align-items: center;
  height: 45px;
  background-image: url("../assets/main_menu_Phone/bg@3x.png");
  position: fixed;
  z-index: 99;
}

.head span {
  color: #ffffff;
  font-size: 20px;
  line-height: 20px;
  font-weight: 550;
}
.back img {
  margin-top: 5px;
}
.titleName {
  display: flex;
  justify-content: center;
}

.back {
  margin: 0 5px;
}

.all_input {
  position: fixed;
  display: flex;
  flex-direction: column;
width: 100%;
  background-color: #ffffff;
  height: 20%;
}

.all_input_top {
  height: 70%;
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  margin: 10px 0;
}

.all_input_bottom {
  height: 50%;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
}

.all_input_top_top {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.all_input_top_bottom {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.all_input_bottom_top {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.all_input_bottom_bottom {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.all_button {
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: space-between;
  margin-bottom: 15px;
  margin-top: 15px;
}
.two_inputs {
  padding: 0 10px;
  align-items: center;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.input {
  margin-bottom: 10px;
}
.ShouQis {
  height: 74px;
  align-items: center;
  display: flex;
  flex-direction: column;

  transform: rotate(180deg);
}
.all_key {
  display: flex;
  flex-direction: column;
  padding :178px 20px 0 20px;
  box-sizing: border-box;
  align-items: center;
}
/* .all_key {
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 0 10px;
  box-sizing: border-box;
} */
.two_spans {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  background-color: aqua;
}
.Key {
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  font-size: 8pt;
  margin-bottom: 4px;
  justify-content: space-between;
}

.serch {
  width: 60%;
}

.list_div {
  margin-top: 20px;
  background: #ffffff;
  background-image: url("../assets/table_logo2.png");

  border-radius: 5px;
  padding: 10px 7px;
  width: 100%;
  margin-bottom: 20px;
  display: flex;
  flex-direction: column;
  /* justify-content: space-between; */
}

.submit_button {
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin-bottom: 10px;
}

.all_second_button {
  display: flex;
  flex-direction: row;
  margin-left: 10px;
}
.titleAndicon {
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}
.title_icon {
  margin-right: 20px;
}
.sousuoButton {
  position: relative;
}
.sousuo_icon {
  top: 16px;
  left: 32px;
  position: absolute;
}
.ChongZhi {
  position: relative;
}
.icon_chong {
  top: 16px;
  left: 14px;
  position: absolute;
}
.ShouQi {
  margin-bottom: 10px;
}
.icon_Shou {
  top: 14px;
  left: 12px;
  position: absolute;
}
.icon_Shous {
  top: 15px;
  left: 12px;
  position: absolute;
  transform: rotate(180deg);
}
.all_spans1 {
  width: 50%;
  display: flex;
  flex-direction: column;
}
.all_spans {
  padding: 0 10px;
}
.titles {
  width: 100%;
  margin-top: 10px;
  display: flex;
}
.ss {
  height: 45px;
}
.XinJiuBianHao {
  width: 100%;
  display: flex;
  justify-content: space-between;
}
.second_span {
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: space-between;
}
.double_span {
  justify-content: space-between;
  display: flex;
  flex-direction: row;
  width: 100%;
}

.double_spans {
  width: 48%;
}
.list_div_divs {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}
.list_div_div {
  width: 30%;
  display: flex;
  flex-direction: column;
  margin-right: 10px;
}
.list_div {
  border-radius: 5px;
  display: flex;
  flex-direction: column;
  margin-top: 15px;
  padding: 6px 14px;
  /* background-image: url(./../assets/img_cx_sylogo@2x.png); */
  background-size: 190px 102px;
}

.list_div_span {
  color: #222222;
}

.list_div_p {
  font-size: 12px;
  line-height: 12px;
  color: #a2a2a2;
  text-align: left;
  margin: 6.5px 0;
}
.input_button {
  height: 37%;
}
</style>
